export interface IDTOUsuarioPrivilegio {
    identificador: string;
    descricao: string;
    valor: boolean;
}

const listaPadraoPrivilegiosUsuario: IDTOUsuarioPrivilegio[] = [
  { identificador: 'CONFIGURACOES', descricao: 'Configurações', valor: false },
  { identificador: 'USUARIOS', descricao: 'Usuários', valor: false },
  { identificador: 'CADASTROS', descricao: 'Cadastros', valor: false },
  { identificador: 'ORIGENS', descricao: 'Origens', valor: false },
  { identificador: 'TIPOS', descricao: 'Tipos', valor: false },
  { identificador: 'DEFINICOES_OCORRENCIAS', descricao: 'Definições de Ocorrências', valor: false },
  { identificador: 'PRIORIDADES', descricao: 'Prioridades', valor: false },
  { identificador: 'OCORRENCIAS', descricao: 'Ocorrências', valor: false },
  { identificador: 'OFICIOS', descricao: 'Ofícios', valor: false },
];

export default listaPadraoPrivilegiosUsuario;
